/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./userfinder.vue?vue&type=template&id=c4cedd8c"
import script from "./userfinder.vue?vue&type=script&lang=js"
export * from "./userfinder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports